import {
  orderEntryCollection,
  orderGuideItemCollection,
} from '@/experiences/sales-portal/domain/ordering/screens/order-entry/blocs/collections/order-entry-collection';
import { usePricingStore } from '@/experiences/sales-portal/domain/ordering/screens/order-entry/blocs/stores/pricing-store';

/**
 * Removes every row from both order-entry collections and drops all price editors.
 */
export const clearOrderEntryCollections = (): void => {
  for (const collection of [orderGuideItemCollection, orderEntryCollection]) {
    const keys = [...collection.keys()];
    if (keys.length > 0) {
      collection.delete(keys);
    }
  }
  usePricingStore.getState().reset();
};
